//@ts-strict-ignore
import classNames from 'classnames';
import React from 'react';

const MenuRenderer = ({
  focusedOption,
  instancePrefix,
  onFocus,
  onSelect,
  optionClassName,
  optionComponent: Option,
  optionRenderer: OptionRenderer,
  options,
  valueArray,
  valueKey,
  onOptionRef,
  values,
  ...rest
}) => {
  return options.map((option, i) => {
    const isSelected = valueArray && valueArray.indexOf(option) > -1;
    const isFocused = option === focusedOption;
    const optionClass = classNames(optionClassName, {
      'Select-option': true,
      'is-selected': isSelected,
      'is-focused': isFocused,
      'is-disabled': option.disabled,
    });

    return (
      <Option
        className={optionClass}
        instancePrefix={instancePrefix}
        isDisabled={option.disabled}
        isFocused={isFocused}
        isSelected={isSelected}
        key={`option-${i}-${option[valueKey]}`}
        onFocus={onFocus}
        onSelect={onSelect}
        option={option}
        optionIndex={i}
        testid={`${rest['data-testid']}-option-${i}`}
        ref={(ref) => {
          onOptionRef(ref, isFocused);
        }}
      >
        <OptionRenderer option={option} values={values} />
      </Option>
    );
  });
};

export default MenuRenderer;
